module.exports = __webpack_public_path__ + "static/media/skin-panel-back.96d31233.png";